import React, { useEffect } from 'react';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import './config/ReactotronConfig';
import { Router } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { DEFAULT_THEME, UiKitTheme } from 'takeat-design-system-ui-kit';
import { QueryClient, QueryClientProvider } from 'react-query';
import GlobalStyle from './styles/global';
import history from './services/history';
import { AuthProvider } from './context/AuthContext';
import { TablesProvider } from './context/TablesContext';
import { NotificationProvider } from './context/notificationContext';
import { OrderProvider } from './context/orderContext';
import { ClosingProvider } from './context/closingContext';
import { CartProvider } from './context/OrderingSystem/Cart';
import { OrderingSystemProvider } from './context/OrderingSystem/Order';
import { MenuProvider } from './context/OrderingSystem/Menu';
import { BillsProvider } from './context/BillsContext';
import { IFoodProvider } from './context/iFoodContext';
import { WaiterTicketProvider } from './context/WaiterTicketContext';
import { MotoboysProvider } from './context/MotoboysContext';
import { ClubeProvider } from './context/ClubeContext';
import { VideosProvider } from './context/VideosContext';

import { PosProvider } from './context/PosContext';
import { PreCartProvider } from './context/PreCartContext';
import { DeliveryOpeningHourProvider } from './context/DeliveryOpeningHour';
import { NotifyProvider } from './context/NotifyContext';
import { CatalogProvider } from './context/CatalogContext';
import AdminLayout from './pages/_layouts/admin';

import Routes from './routes';
import { ChatProvider } from './components/ChatProvider';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: false,
    },
  },
});

function App() {
  const CUSTOM_THEME = {
    ...DEFAULT_THEME,
    colors: {
      ...DEFAULT_THEME.colors,
      secondary: '#ff403d',
      tertiary: '#90C2E7',
      confirm: '#7fd1b9',
      info: '#eac435',
      white: '#fff',
      gray: '#97928F',
      lightGray: '#ddd',

      background: '#F0F0EF',
      text: '#333',
    },
  };
  const page = window.location.pathname;

  useEffect(() => {
    const { body } = document;
    if (page === '/kds-password') {
      body.classList.add('hide-hubspot-chat');
    } else {
      body.classList.remove('hide-hubspot-chat');
    }
  }, [page]);

  return (
    <QueryClientProvider client={queryClient}>
      <ChatProvider />
      <UiKitTheme theme={CUSTOM_THEME}>
        <Router history={history}>
          <AuthProvider>
            <DeliveryOpeningHourProvider>
              <PosProvider>
                <VideosProvider>
                  <BillsProvider>
                    <TablesProvider>
                      <NotificationProvider>
                        <OrderProvider>
                          <IFoodProvider>
                            <ClosingProvider>
                              <DndProvider backend={HTML5Backend}>
                                <OrderingSystemProvider>
                                  <PreCartProvider>
                                    <CartProvider>
                                      <MenuProvider>
                                        <MotoboysProvider>
                                          <ClubeProvider>
                                            <WaiterTicketProvider>
                                              <NotifyProvider>
                                                <CatalogProvider>
                                                  <GlobalStyle />
                                                  <AdminLayout>
                                                    <Routes />
                                                  </AdminLayout>
                                                  <Toaster
                                                    toastOptions={{
                                                      duration: 3000,
                                                      style: {
                                                        padding: '12px 10px',
                                                        boxShadow:
                                                          '0 1px 10px rgb(0 0 0 / 30%)',
                                                      },
                                                      success: {
                                                        style: {
                                                          border:
                                                            '2px solid #61d345',
                                                        },
                                                      },
                                                      error: {
                                                        style: {
                                                          border:
                                                            '2px solid #ff4b4b',
                                                        },
                                                      },
                                                    }}
                                                  />
                                                </CatalogProvider>
                                              </NotifyProvider>
                                            </WaiterTicketProvider>
                                          </ClubeProvider>
                                        </MotoboysProvider>
                                      </MenuProvider>
                                    </CartProvider>
                                  </PreCartProvider>
                                </OrderingSystemProvider>
                              </DndProvider>
                            </ClosingProvider>
                          </IFoodProvider>
                        </OrderProvider>
                      </NotificationProvider>
                    </TablesProvider>
                  </BillsProvider>
                </VideosProvider>
              </PosProvider>
            </DeliveryOpeningHourProvider>
          </AuthProvider>
        </Router>
      </UiKitTheme>
    </QueryClientProvider>
  );
}

export default App;
